export class ColorUtility {
  public hexToRgb(hex: string): { r: number; g: number; b: number } | null {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

    return result
      ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16)
        }
      : null;
  }

  public colorIsLight(hex: string): boolean {
    const rgb = this.hexToRgb(hex);

    if (!rgb) {
      return false;
    }

    const opacity = Math.round((rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000);
    return opacity > 180;
  }

  public idealTextColor(hex: string): string {
    const darkText = '#444';
    const lightText = '#fff';

    if (!hex || hex.toLowerCase() === 'transparent') {
      return darkText;
    }

    return this.colorIsLight(hex) ? darkText : lightText;
  }
}
